import x from "./SetNotesReservationsButton";

export const SetNotesReservationsButton = x;
